import { render, staticRenderFns } from "./MarketplaceTemplateOLD.vue?vue&type=template&id=d536b044&"
import script from "./MarketplaceTemplateOLD.vue?vue&type=script&lang=js&"
export * from "./MarketplaceTemplateOLD.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports